export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSlevamat';
export const NAME = 'SlevaMaterialu';
